<template>
  <a-modal
    :visible="true"
    :title="`정말로 수정하시겠습니까?`"
    @ok="onSave"
    :okText="`네, 수정합니다.`"
    @cancel="onClose"
    cancelText="아니요"
  >
    <p style="margin-left: 10px; margin-top: 0.5em;">
      <b>- 기본 정보:</b>
    </p>
    <p style="margin-left: 20px">
      <b>- 거래 타입:</b>&nbsp;
      <b>
        <span v-if="saib.type === 0" class="cl-green">사입</span>
        <span v-else-if="saib.type === 1" class="cl-red">교환 / 반납</span>
        <span v-else class="cl-yellow">알 수 없음</span>
      </b>
    </p>
    <p style="margin-left: 20px;">
      <b>- 사용자 이름:</b>
      {{ saib.account.username }}
    </p>
    <p style="margin-left: 20px;">
      <b>- 등록 시간:</b>
      {{ $moment(saib.uploadAt).format('llll') }}
    </p>
    <br />
    <p style="margin-left: 10px;">
      <b>- 도매 정보:</b>
    </p>
    <p style="margin-left: 20px;">
      <b>- 이름:</b>
      {{ saib.wholesale.name }}
    </p>
    <p style="margin-left: 20px;">
      <b>- 전화번호:</b>
      <a
        class="ant-btn"
        :href="`tel://${saib.wholesale.phone}`"
        style="color: #000;"
      >{{ saib.wholesale.phone }}</a>
    </p>
    <p style="margin-left: 20px;">
      <b>- 휴대폰:</b>
      <a
        class="ant-btn"
        :href="`tel://${saib.wholesale.mobile}`"
        style="color: #000;"
      >{{ saib.wholesale.mobile }}</a>
    </p>
    <br />
    <a-radio-group buttonStyle="solid" style="margin-bottom: 0.3em;" v-model="saib.status">
      <a-radio-button :value="1">
        <a-icon type="sync" />&nbsp;처리
      </a-radio-button>
      <a-radio-button :value="3">
        <a-icon type="close" />&nbsp;실패
      </a-radio-button>
      <a-radio-button :value="4" v-if="saib.type === 0">
        <a-icon type="warning" />&nbsp;대기
      </a-radio-button>
      <a-radio-button :value="4" v-else>
        <a-icon type="warning" />&nbsp;맡김
      </a-radio-button>
      <a-radio-button :value="2">
        <a-icon type="check" />&nbsp;성공
      </a-radio-button>
    </a-radio-group>
    <a-table :columns="columns" :dataSource="saib.details" size="small" :pagination="false">
      <p
        :slot="saib.status !== 1 ? 'expandedRowRender' : ''"
        style="margin: 0"
        slot-scope="record, index"
      >
        <a-input
          v-model="saib.details[index].reason"
          placeholder="메세지를 입력해주세요."
          :style="`margin-top: 0.5em; ${saib.status === 2 ? 'width: 55%' : ''}`"
        />
        <a-input-number
          v-if="status === 2"
          v-model="saib.details[index].price"
          placeholder="금액"
          @change="onChangePrice"
          :formatter="
                value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
          :parser="value => value.replace(/\$\s?|(,*)/g, '')"
          :style="
                `margin-top: 0.75em; margin-left: 0.3em; ${
                  saib.status === 2 ? 'margin-right: 0.3em; width: 35%;' : ''
                }`
              "
        />
      </p>
    </a-table>
    <a-input
      v-if="saib.status !== 1"
      v-model="saib.reason"
      placeholder="메세지를 입력해주세요."
      :style="`margin-top: 0.5em; ${saib.status === 2 ? 'width: 60%' : ''}`"
    />
    <a-input-number
      v-if="saib.status === 2"
      style="margin-top: 0.3em; margin-left: 0.3em; width: 35%;"
      @change="onFirstPrice"
      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
      placeholder="금액"
      v-model="saib.price"
    />
    <p v-if="saib.type !== 0" style="margin-top: 0.5em;">
      <b>사유:</b>
      {{ saib.reason || '별도의 사유를 작성하지 않으셨습니다.' }}
    </p>
    <p v-if="saib.sended" style="margin-top: 0.5em;">
      <b>도매 메세지:</b>
      {{ saib.answer || '메세지가 아직 오지 않았습니다.' }}
    </p>
  </a-modal>
</template>
<script>
import AxiosMiddleware from "../../../libs/AxiosMiddleware";
import config from "../../../config";
import Axios from "axios";
import OPCODE from "../../../libs/OPCODE";
export default {
  name: "UncleSaibCompletedEdit",
  props: ["saib", "onClose"],
  mounted() {
    this.$forceUpdate();
  },
  methods: {
    async onSave() {
      try {
        const { reason, details, price } = this.saib;
        const { data } = await Axios.post(
          `${config.hostname}/v1/uncle/saib/completed/${this.saib.idx}?status=${this.saib.status}`,
          { reason, details, price },
          { withCredentials: true }
        );

        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              config.alert.mixin({
                type: "success",
                title: "성공적으로 수정되었습니다."
              });
              await this.onClose();
              break;
            default:
              config.alert.mixin({
                type: "error",
                title: "알 수 없는 오류가 발생했습니다."
              });
              break;
          }
        }
      } catch (err) {
        config.alert.mixin({
          type: "error",
          title: "인터넷에 연결할 수 없습니다.\n인터넷 상태를 확인해주세요."
        });
      }
    },
    onFirstPrice() {
      let isFirst = true;
      if (!this.saib.price) this.saib.price = 0;
      for (const i in this.saib.details) {
        if (isFirst) {
          this.saib.details[i].price = this.saib.price;
          isFirst = false;
        } else {
          this.saib.details[i].price = 0;
        }
      }
      this.onChangePrice();
    },
    onChangePrice() {
      this.saib.price = 0;
      for (const detail of this.saib.details) {
        this.saib.price += parseInt(detail.price || 0);
      }
    }
  },
  data() {
    return {
      columns: [
        {
          title: "품명",
          dataIndex: "name"
        },
        {
          title: "수량",
          dataIndex: "amount"
        }
      ]
    };
  }
};
</script>